import { decimal, money } from '@/js/shared/billables/decimal';

export function calculateSectionTotals(items) {
  const subtotal = items.reduce((sum, item) => sum.plus(money(item.total)), decimal(0));
  const cost = items.reduce((sum, item) => sum.plus(money(item.cost)), decimal(0));
  const margin = subtotal.minus(cost);
  const marginPercentage = subtotal.eq('0')
    ? decimal(0)
    : margin.div(subtotal).times('100').round(0);
  const marginAvailable = items.every((item) => !item.unitPriceMissing);

  return {
    subtotal: subtotal.toFixed(2),
    margin: margin.toFixed(2),
    marginPercentage: marginPercentage.toFixed(0),
    marginAvailable,
  };
}
